<script>
  import { Router, Route } from 'svelte-routing';
  import { onMount } from 'svelte';
  import { isAuthenticated, user } from './lib/stores.js';
  
  // Pages
  import Login from './pages/Login.svelte';
  import Dashboard from './pages/Dashboard.svelte';
  import NotFound from './pages/NotFound.svelte';
  
  // Get the base URL from the environment
  let url = '';
  
  // For Svelte compatibility, we need to track authentication state
  let auth = false;
  let userData = null;
  
  // Subscribe to stores
  const unsubscribeAuth = isAuthenticated.subscribe(value => {
    auth = value;
  });
  
  const unsubscribeUser = user.subscribe(value => {
    userData = value;
  });
  
  onMount(() => {
    // Check if token exists in localStorage
    const token = localStorage.getItem('token');
    if (token) {
      // Validate token on page load
      fetch('/api/auth/verify', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          isAuthenticated.update(() => true);
          user.update(() => data.user);
        } else {
          // Clear invalid token
          localStorage.removeItem('token');
          isAuthenticated.update(() => false);
          user.update(() => null);
        }
      })
      .catch(err => {
        console.error('Error verifying token:', err);
        localStorage.removeItem('token');
        isAuthenticated.update(() => false);
        user.update(() => null);
      });
    }
    
    // Clean up subscriptions
    return () => {
      unsubscribeAuth();
      unsubscribeUser();
    };
  });
</script>

<Router {url}>
  <div class="app-container">
    <Route path="/" component={auth ? Dashboard : Login} />
    <Route path="/login" component={Login} />
    <Route path="/dashboard/*" component={auth ? Dashboard : Login} />
    <Route path="*" component={NotFound} />
  </div>
</Router>

<style>
  :global(body) {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background-color: #f5f5f5;
  }
  
  :global(*) {
    box-sizing: border-box;
  }
  
  .app-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
</style>